import React from "react";
import { VegaChip } from "@heartlandone/vega-react";

const ActivityPendingFeedbackState = ({hasFeedback}) => {
  return (
    !hasFeedback && <VegaChip
      text={"Pending Feedback"}
      size="small"
      bgColor="bg-accent8-tertiary"
      textColor="text-accent8-primary"
    ></VegaChip>
  );
};

export default ActivityPendingFeedbackState;
